import { StrictMode } from 'react'

// eslint-disable-next-line react/prop-types
export default function DynamicStrictMode({ children }) {
    return import.meta.env.VITE_USE_STRICT === 'true' ? <StrictMode>{children}</StrictMode> : children
}
